// src/apiClient.js (User App)
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_USER_API_URL || 'http://127.0.0.1:8000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- Request Interceptor for Participant Token ---
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('participantToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // If the data is FormData, allow Axios to set the correct multipart/form-data header.
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    console.error('User App Axios request interceptor error:', error);
    return Promise.reject(error);
  }
);

// --- Response Interceptor (Optional) ---
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('User App Axios response interceptor error:', error.response || error.message);
    if (error.response && error.response.status === 401) {
      // Token is invalid or expired
      localStorage.removeItem('participantToken');
      // Optionally redirect to login or trigger a global logout state update
      // This depends on how you want to handle forced logouts.
      // For now, just removing the token. The UI should react accordingly.
      // Example: window.location.href = '/'; // (might need to pass 'p' param back)
    }
    return Promise.reject(error);
  }
);

export default apiClient;